import { createFileRoute, Link } from '@tanstack/react-router'

import { preloadGetMe, useGetMe } from '@/api/react-query'
import { Container, ContainerHeader } from '@/components/base/container'
import { IconButton } from '@/components/base/icon-button'
import { SectionRow } from '@/components/base/section-row'
import { SingleColumnPage } from '@/components/page-layout'
import { useI18n } from '@/i18n/i18n-react'
import { PencilSquare } from '@/icons/pencil-square'
import { ConditionalRouteComponent } from '@/utils/route-utilities'

export const Route = createFileRoute('/_authenticated/settings/profile')({
	component: () => (
		<ConditionalRouteComponent routePath={Route.id} pathsToRenderOn={['/edit']}>
			<ProfileSettings />
		</ConditionalRouteComponent>
	),
	loader: async ({ context }) => await preloadGetMe(context, {}),
	staticData: { crumb: ({ context: { L } }) => L.Profile.Title() }
})

function ProfileSettings() {
	const { L } = useI18n()
	const me = useGetMe()

	const getLocaleName = (localeCode: string | undefined) => {
		if (!localeCode) return L.General.NotSet()
		return localeCode === 'en'
			? 'English'
			: localeCode === 'is'
				? 'Íslenska'
				: localeCode === 'nb'
					? 'Norsk Bokmål'
					: localeCode === 'da'
						? 'Dansk'
						: localeCode === 'sv'
							? 'Svenska'
							: localeCode
	}

	return (
		<SingleColumnPage hasOutlet>
			<Container className='divide-y'>
				<ContainerHeader
					heading={me.data?.displayName || L.Settings.Profile.Title()}
					rightSide={
						<Link from={Route.fullPath} to='edit'>
							<IconButton tooltipText={L.General.Edit()}>
								<PencilSquare />
							</IconButton>
						</Link>
					}
				/>
				<SectionRow title={L.Fields.Name()} value={me.data?.displayName || L.General.NotSet()} />
				<SectionRow title={L.Fields.Email()} value={me.data?.email || L.General.NotSet()} />
				<SectionRow title={L.Fields.Language()} value={getLocaleName(me.data?.locale)} />
			</Container>
		</SingleColumnPage>
	)
}
